import { $myFetch } from "."
import { ITax } from "../../models/bo"
import { LocalStorageKeys } from "../../utils/local-storage-keys"

export const $getVat = (supplierName?: string): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(
    "vat/vat",
    {
      headers: myHeaders,
    },
    undefined,
    undefined,
    supplierName
  )
}

export const $getTaxes = (supplierName?: string): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(
    "vat/taxes",
    {
      headers: myHeaders,
    },
    undefined,
    undefined,
    supplierName
  )
}
